import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

const authHeaders = () => ({
    Authorization: `Bearer ${localStorage.getItem("token")}`,
});

const BASE = `${API_URL}/admin/duplicate-people`;

export interface DuplicatePerson {
    _id: string;
    name: string;
    /** "MM-YYYY", or null when no birthdate is known — which is itself a reason to be listed. */
    birthdate: string | null;
    qualite?: string;
    role?: string;
    enrichmentsWithData: number;
    hasLinkedin: boolean;
    linkedEstablishments: number;
    createdAt?: string;
}

export interface DuplicateGroup {
    name: string;
    /** true when at least two of these people carry a known and different birthdate. */
    confident: boolean;
    people: DuplicatePerson[];
}

export interface FlaggedEstablishment {
    _id: string;
    name?: string;
    siren?: string;
    siret?: string;
    city?: string;
    groups: DuplicateGroup[];
}

export interface DuplicatePeopleResponse {
    total: number;
    page: number;
    limit: number;
    scanned: number;
    computedAt: string;
    truncated: boolean;
    results: FlaggedEstablishment[];
}

export async function getDuplicatePeople(params: {
    page?: number;
    limit?: number;
    confidentOnly?: boolean;
    matchOnKey?: boolean;
    refresh?: boolean;
}): Promise<DuplicatePeopleResponse> {
    const { data } = await axios.get(BASE, {
        headers: authHeaders(),
        params: {
            page: params.page ?? 1,
            limit: params.limit ?? 25,
            confidentOnly: params.confidentOnly === false ? "0" : "1",
            ...(params.matchOnKey ? { match: "key" } : {}),
            ...(params.refresh ? { refresh: "1" } : {}),
        },
    });
    return data;
}

export async function deleteDuplicatePerson(personId: string): Promise<{
    deleted: boolean;
    name: string;
    unlinkedFromEstablishments: number;
    unlinkedFromEvents: number;
}> {
    const { data } = await axios.delete(`${BASE}/person/${personId}`, {
        headers: authHeaders(),
    });
    return data;
}

/** Pappers indexes companies by SIREN — the same 9 digits the establishment carries. */
export const pappersUrl = (siren?: string): string | null =>
    siren && /^\d{9}$/.test(siren) ? `https://www.pappers.fr/entreprise/${siren}` : null;
